import React, { useEffect, useState } from 'react';
import { ShieldCheck, Lock } from 'lucide-react';
export function GuaranteeSection() {
  // 5 minute countdown timer
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timerId = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timerId);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes}:${seconds.toString().padStart(2, '0')}`;
  return <section className="pt-12 pb-6 px-4 bg-[#0a0c0e] border-t border-card-border" data-id="element-134">
      <div className="max-w-4xl mx-auto text-center" data-id="element-135">
        <div className="flex justify-center mb-8" data-id="element-136">
          <div className="relative" data-id="element-137">
            <div className="absolute inset-0 bg-cyan-neon/20 blur-xl rounded-full" data-id="element-138"></div>
            <ShieldCheck className="w-24 h-24 text-cyan-neon relative z-10" data-id="element-139" />
          </div>
        </div>

        <h2 className="font-bebas text-4xl md:text-5xl text-white mb-6" data-id="element-140">
          GARANTÍA DE HIERRO <span className="text-cyan-neon" data-id="element-141">7 DÍAS</span>
        </h2>

        <p className="font-inter text-lg md:text-xl text-text-muted mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-142">
          "Si no recuperas tu energía y coherencia desde la primera noche, te
          devuelvo cada centavo. Sin preguntas. El riesgo es mío."
        </p>

        <div className="flex flex-col items-center justify-center gap-4 mb-4" data-id="element-143">
          <div className="flex items-center gap-2 text-text-muted font-inter text-sm bg-card-dark px-6 py-3 rounded-full border border-card-border" data-id="element-144">
            <Lock className="w-4 h-4 text-cyan-neon" data-id="element-145" />
            <span data-id="element-146">
              Pago 100% Seguro Procesado por <strong data-id="element-147">Hotmart</strong>
            </span>
          </div>
        </div>
      </div>
    </section>;
}